import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_ORIGIN } from './site';

/** JSON-LD for the public homepage (WebSite + Organization). Facts only — no invented metadata. */
export function buildHomePageJsonLd(description: string) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        name: SITE_NAME,
        url: `${SITE_ORIGIN}/`,
        description,
        publisher: { '@id': `${SITE_ORIGIN}/#organization` },
      },
      {
        '@type': 'Organization',
        '@id': `${SITE_ORIGIN}/#organization`,
        name: SITE_NAME,
        url: `${SITE_ORIGIN}/`,
        logo: {
          '@type': 'ImageObject',
          url: DEFAULT_OG_IMAGE,
        },
        description:
          'RideMaadi is a motorcycle riding and group ride app that helps riders and riding groups plan rides and ride together.',
      },
    ],
  };
}

export function jsonLdScriptTag(data: object): string {
  return `<script type="application/ld+json">${JSON.stringify(data)}</script>`;
}
